/**
 * Convert form date strings into pill format
 * Examples:
 *   "05 Sep 1995"  -> { day: "05", month: "09", year: "1995" }
 *   "Sep 2013"     -> { day: "", month: "09", year: "2013" }
 */
export function toPillDate(value) {
  if (!value || typeof value !== 'string') {
    return { year: '', month: '', day: '' };
  }

  // Map short month names to numbers
  const monthMap = {
    Jan: '01',
    Feb: '02',
    Mar: '03',
    Apr: '04',
    May: '05',
    Jun: '06',
    Jul: '07',
    Aug: '08',
    Sep: '09',
    Oct: '10',
    Nov: '11',
    Dec: '12',
  };

  const parts = value.trim().split(/\s+/); // split by space(s)
  let day = '',
    month = '',
    year = '';

  if (parts.length === 3) {
    // e.g. "05 Sep 1995"
    [day, month, year] = parts;
    day = day.padStart(2, '0'); // ensure two digits
    month = monthMap[month] || '';
  } else if (parts.length === 2) {
    // e.g. "Sep 2013"
    [month, year] = parts;
    month = monthMap[month] || '';
  } else if (parts.length === 1) {
    // Just a year case: "1995"
    year = parts[0];
  }

  return { year, month, day };
}

/**
 * Overload: Convert discrete year/month/day parts into pill format.
 * Accepts 1- or 2-digit month/day and pads to 2 digits.
 *
 * Examples:
 *   toPillDateParts("2013", "9")        -> { year:"2013", month:"09", day:"" }
 *   toPillDateParts(2013, 9, 5)         -> { year:"2013", month:"09", day:"05" }
 *   toPillDateParts("1995")             -> { year:"1995", month:"",  day:"" }
 */
export function toPillDateParts(year, month, day = '') {
  const y = year != null ? String(year).trim() : '';
  const m = month != null ? String(month).trim() : '';
  const d = day != null ? String(day).trim() : '';

  return {
    year: y || '',
    month: m ? m.padStart(2, '0') : '',
    day: d ? d.padStart(2, '0') : '',
  };
}
